<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<!-- 품번 -->
					<search-input :label="getMessage_('QWCC000956')" paramKey="partNo" @commInput="setSearchParam" :propData="searchDtlParams.partNo">
					</search-input>
				</el-col>
				<el-col :span="5">
					<!-- 품명 -->
					<search-input
						:label="getMessage_('QWCC000957')"
						paramKey="partName"
						@commInput="setSearchParam"
						:propData="searchDtlParams.partName"
					>
					</search-input>
				</el-col>
				<!-- 협력사 -->
				<el-col :span="5">
					<search-input
						:label="getMessage_('QWCC000958')"
						paramKey="cofCd"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchDtlParams.cofCd"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onCofPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 검사기간 -->
				<el-col :span="8">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001224') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>

		<!-- 협력사 팝업 -->
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		propPartNo: { type: String, default: '' }
	},
	components: {
		SearchInput,
		CompPopup
	},
	data() {
		return {
			partNo: '',
			partName: '',
			searchDateRange: []
		};
	},
	created() {
		// console.log('create search >>>>>', this.propPartNo);
		try {
			this.searchDateRange = [...this.getSearchMonths_];
			// await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}

		this.searchDtlParams.partNo = this.propPartNo;
		//this.searchDtlParams.searchDateRange = [...this.getSearchMonths_];
		this.searchList();
	},
	watch: {
		searchDateRange(newValue) {
			// console.log('newValue >>>>', newValue, newValue?.length == 2);
			if (newValue == null) {
				this.setSearchParam({ key: 'strDt', value: '' });
				this.setSearchParam({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				// console.log('newValue strDt>>>>', strDt, endDt);
				this.setSearchParam({ key: 'strDt', value: strDt });
				this.setSearchParam({ key: 'endDt', value: endDt });
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		searchList() {
			// console.log('PqPartPopupSearch 에서 searchList 실행>>>', this.searchDtlParams);
			// console.log('searchList >>>>>', this.propPartNo);
			this.$sf_toggleLoading(true);
			this.getPartPopupResults_(this.searchDtlParams)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
					this.$sf_toggleLoading(false);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		setSearchParam({ key, value }) {
			this.searchDtlParams[key] = value;
		},
		resetParam(param) {
			// console.log('reset >>> ', param);
			this.partNo = param ? param : '';
			this.searchDtlParams.partNo = param ? param : '';
			this.partName = '';
		},
		// 협력사조회
		onCofPopup() {
			let params = {
				cpnyScn: '10',
				cpnyCd: this.searchDtlParams.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam({ key: 'cofCd', value: cpnyCd });
			this.setSearchParam({ key: 'cofNm', value: cpnyNm });
		}
	}
};
</script>

<style></style>
